import styled from "styled-components"
import Title from "./Title"
import { memo, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { allAnimations } from "../effects/Observers"
import { useTranslation } from "react-i18next"
import { device } from "../styles/stylesConfig"

const Container = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background-color: #111;
    padding: 0px 10vw;

    @media ${device.md} {
    padding: 2.5vh 10vw;
    }
`

const ContentContainer = styled.div`
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    h1 {
        font-size: 32px;
        white-space: nowrap;

        @media ${device.lg} {
            font-size: 24px;
        }
        @media ${device.md} {
            font-size: 20px;
            white-space: normal;
            text-align: center !important;
        }
        @media ${device.sm} {
            font-size: 16px;
        }
    }

    @media ${device.md} {
        margin: 0;
    }

    div {
        margin: 0;
    }
`

const Image = styled.img`
    object-fit: contain;
    position: absolute;
    width: 300px;
    bottom: 15vh;

    @media ${device.lg} {
        width: 200px;
        bottom: 5vh;
    }

    @media ${device.md} {
        display: none;
    }
`

const WhoAreWeComponent = () => {

    const location = useLocation();

    const { t } = useTranslation();

    useEffect(() => {

        allAnimations();

        return () => { allAnimations() };

    }, [location.pathname])

    const [windowSize, setWindowSize] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getTitle = () => {
        if (windowSize >= 900) {
            return t('about.title');
        } else if (windowSize >= 600) {
            return t('about.title').replaceAll("<br/>", " ")
        } else {
            return t('about.title').replace("<br/>", " ")
        }

    };

    return (

        <Container>

            <ContentContainer>

                <Title
                    titleColor="white"
                    title={getTitle()}
                    textAlign="end"
                    titleStyle={{ width: 'fit-content' }}
                />

            </ContentContainer>

            <Image className="utils__fade-in-fast-top" src={require('../images/logo-blanco.png')} alt="Logo Aluviher" />

        </Container>

    )
}

const WhoAreWe = memo(WhoAreWeComponent);

export default WhoAreWe;